module.exports = __webpack_public_path__ + "img/facebook-messenger.png";